import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlStatusMessage, StatusMessage} from '../../../graphql/common.datatypes';

interface VerifyEmailVars {
    id: string
    email: string
}

interface VerIfyEmailData {
    verifyEmail: StatusMessage
}

export const VERIFY_EMAIL_MUTATION = gql`
    mutation verifyEmail($id: String!, $email: String!) {
        verifyEmail(id: $id, email: $email) {
            ${gqlStatusMessage}
        }
    }
`;

export const verifyEmail = () => useMutation<VerIfyEmailData, VerifyEmailVars>(
    VERIFY_EMAIL_MUTATION, {}
);

export default verifyEmail;
